import { combineReducers } from 'redux';

import { ActionTypes } from '../actions/actions';

const reportInitialState = {
    grade: null,
    dataBySetName: null,
    analysisBySetName: null,
    errorMessage: "Loading report"
};
export const barProfitReportReducer = (state = reportInitialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_REPORT_DATA:
            return {
                ...state,
                ...action.data,
            };

        default:
            return state
    }
};